import api from '../../helpers/api';

export const getArtisanStatistics = id => {
  return api.get(`statistics/artisan-statistics/${id}`);
};
export const getSupplierStatistics = id => {
  return api.get(`statistics/supplier-statistics/${id}`);
};
export const getCustomerStatistics = id => {
  return api.get(`statistics/customer-inquiries/${id}`);
};
export const getAdminStatistics = id => {
  return api.get(`statistics/admin`);
};

export const getSuperStatistics = id => {
  return api.get(`statistics/super-admin`);
};
